import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-footer-page',
    templateUrl: './footer-page.component.html',
    styleUrls: ['./footer-page.component.css'],
    standalone: false
})
export class FooterPageComponent implements OnInit {

    @Input() end = false
    @Input() labelConfirmar = 'Salvar'
    @Input() labelCancelar = 'Cancelar'
    @Input() labelTerceiro = 'voltar'
    @Input() terceiro = false

    @Output() cancelar = new EventEmitter<any>()
    @Output() confirmar = new EventEmitter<any>()
    @Output() terceiroAcao = new EventEmitter<any>()

    constructor() {
    }

    ngOnInit() {
    }

    clickCancelar() {
        this.cancelar.emit()
    }

    clickConfirmar() {        
        this.confirmar.emit()
    }

    clickTerceiro(){
        this.terceiroAcao.emit()
    }
}
